import React from 'react';
import './App.css';
import '../src/styles/style.css';
import '../src/styles/responsive.css';
import '../node_modules/font-awesome/css/font-awesome.min.css'; 
import Routing from './routers/Routing';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <React.Fragment>
        <ToastContainer/>
        <Routing/>
  </React.Fragment>
  );
}

export default App;
